import { HeroModuleItemType } from '../API';

export function shouldDisplayScheduleTimes(heroItemType: HeroModuleItemType): boolean {
  return (
    heroItemType === HeroModuleItemType.CHANNEL ||
    heroItemType === HeroModuleItemType.VOD ||
    heroItemType === HeroModuleItemType.EVENTS ||
    heroItemType === HeroModuleItemType.PAGE ||
    heroItemType === HeroModuleItemType.COLLECTION_LINK ||
    heroItemType === HeroModuleItemType.CLIPS ||
    heroItemType === HeroModuleItemType.PROMOTION
  );
}
